<template>
 <div class="container">
  <ToastPrime />
  <div class="table-display2">
     <div class="cell-display div2">
       <div class="card">
        <div class="formgrid grid">
          <div class="field col-12 md:col-2 text-left">
            <label for="shipName">{{ $t("shipName") }}</label>
             <p
               id="shipName"
               class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.name }}</strong></p>
          </div>
          <div class="field col-12 md:col-2 text-left">
            <label for="shipIMO">{{ $t("imoNumber") }}</label>
             <p
               id="shipIMO"
               class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.imo }}</strong></p>
          </div>
          <div class="field col-12 md:col-2 text-left">
            <label for="shipType">{{ $t("shipType") }}</label>
             <p
               id="shipType"
               class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.shipType.name }}</strong></p>
          </div>
          <div class="field col-12 md:col-2 text-left">
            <label for="shipGT">{{ $t("grossTonnage") }} - <strong>GT</strong> (t)</label>
            <p
              id="shipGT"
              class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.gt}}</strong></p>
          </div>
          <div class="field col-12 md:col-2 text-left">
            <label for="shipDWT">{{ $t("capacityDeadWeight") }} - <strong>DWT</strong> (t)</label>
            <p
              id="shipDWT"
              class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.dwt }}</strong></p>
          </div>
          <div class="field col-12 md:col-2 text-left">
            <label for="shipTotalDistance">{{ $t("totalDistance") }} (mn)</label>
            <p
              id="shipTotalDistance"
              class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.totalDistance}}</strong></p>
          </div>
          <div class="field col-12 md:col-2 text-left">
            <label for="iceClass">{{ $t("iceClass") }}</label>
            <p
              id="iceClass"
              class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.iceClassType.name}}</strong></p>
          </div>
        </div>

        <div class="formgrid grid">
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-4">
            <FuelConsumptionTable :fuelArray = "fuelConsumptionArray"></FuelConsumptionTable>
          </div>
        </div>

        <div class="field col-12 md:col-12 p-2"></div>
        <div class="input-box">
          <div style="display: flex;">
            <div class="field col-12 md:col-1 text-left">
                <label for="priceEUA">{{ $t("inputPriceEUA") }} <strong>(€)</strong>:</label>
                <input
                v-model="priceEUA"
                type="number"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                />
            </div>
            <div class="field col-12 md:col-8 text-left">
              <div style="padding-left: 10%;">
                <label for="questionGWPValues">{{ $t("questionGWPValues") }}</label>
                <SelectButton
                id="questionGWPValues"
                name="selectedGWPOPtion"
                v-model="selectedGWPOPtion"
                :options="optionsGWP"
                />
              </div>
            </div>
            <div class="field col-12 md:col-3 text-left">
              <div style="padding-left: 50%;">
                <ButtonPrime @click="calcETSValues()" id="add-button" class="button">{{ $t("calculate") }}</ButtonPrime>
              </div>
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-12 p-2"></div>
        <div style="display: flex;">
          <p for="yearOptions" style="padding-top: 20px; padding-right: 10px;"><strong>{{ $t("year") }}:</strong></p>
          <DropdownPrime
            id="yearOptions"
            v-model="yearSelected"
            :options="allYears"
            class="field col-1 md:col-1"
          />
        </div>
       
        <!-- ARRAY DE VALORES A FILTRAR POR AÑO-->
        <div class="output-box">
          <div v-for="(item, index) in filteredETSVariables" :key="index">
           <div style="display: flex; justify-content: space-around;">
            <div class="field col-12 md:col-2 text-left">
              <label for="anualEmissions">{{ $t("anualEmissions") }}:</label>
              <p
                id="anualEmissions"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ item.anualEmissions }}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="emissionRights">{{ $t("emissionRights") }}:</label>
              <p
                id="emissionRights"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ item.emissionRights }}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="costEUA">{{ $t("costEUA") }} - (€):</label>
              <p
                id="costEUA"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ item.costEUA }}</strong></p>
            </div>
           </div>
          </div>
        </div>

        <div class="field col-12 md:col-12 p-2"></div>
        <div style="padding-left: 70%;">
          <ButtonPrime @click="save()" id="add-button" class="button">{{ $t("save") }}</ButtonPrime>
          &ensp; &ensp; &ensp; &ensp;
          <ButtonPrime @click="cancel()" id="add-button" class="button">{{ $t("cancel") }}</ButtonPrime>
        </div>
        <!--Párrafos de separación-->
        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>

       </div>
     </div>
   </div>
 </div>

</template>

<script>
import router from "@/router/index";
import utils from "@/utils/configuration/config.js";
import store from "@/store/index";
import ShipService from "@/services/ShipService";
import ParametricTableService from "@/services/ParametricTableService";
import ETSService from "@/services/Neobuq/ETSService";
import FuelConsumptionTable from "./FuelConsumptionTable.vue";
import { ToastSeverity } from "primevue/api";

export default{

  components:{
    FuelConsumptionTable,
  },
 
  data(){
    return{
      ship: store.getters.currentShip,
      fuelConsumptionArray : store.getters.currentShip.fuelConsumption,

      priceEUA : 0,
      optionsGWP: ["RED", "IPCC"],
      selectedGWPOPtion : "",

      allYears: ["2023","2024","2025","2026","2027","2028","2029","2030","2031","2032","2033","2034","2035","2036","2037","2038",
      "2039", "2040"],
      yearSelected: "2023",

      anualEmissions: 0,
      emissionRights: 0,
      costEUA : 0,

      //array de datos según el año
      anualETSVariables : store.getters.currentShip.baseETS
    }
  },

  created(){
    this.shipService = ShipService.getInstance();
    this.etsService = ETSService.getInstance();
    ParametricTableService.getInstance().getParametricTable(utils.config.firebaseConfig.parametricVersion);

    if(store.getters.currentShip.dataForETS != null || store.getters.currentShip.dataForETS != undefined){
      this.priceEUA = store.getters.currentShip.dataForETS.priceEUA
      this.selectedGWPOPtion = store.getters.currentShip.dataForETS.selectedGWPOPtion
      this.anualETSVariables = store.getters.currentShip.baseETS

    }else{

      if(this.anualETSVariables == undefined || this.anualETSVariables == null || this.anualETSVariables.length == 0){
        for(let i=0; i< this.allYears.length; i++){
          var aux2 = {year: this.allYears[i], anualEmissions : 0, emissionRights: 0, costEUA: 0}
          this.anualETSVariables.push(aux2)
        }
      }
      this.priceEUA = 0
      this.selectedGWPOPtion = "RED"
    }

  },

  computed:{
    filteredETSVariables() {
      return this.anualETSVariables.filter(item => item.year === this.yearSelected);
    }
  },

  methods:{

    calcETSValues(){
      //console.log("Calculando los valores del ETS para todos los años...")
      this.anualETSVariables = this.etsService.calc_ets_values(this.ship, this.anualETSVariables, this.priceEUA, this.selectedGWPOPtion)
      //lo guardamos en ship
      this.ship.baseETS = this.anualETSVariables
    },
    save(){
      //console.log("Guardando ETS...")
      const errorsInSave = this.shipService.saveShip(store.getters.currentShip);

      if (errorsInSave === "") {
        this.$toast.add({
          severity: ToastSeverity.SUCCESS,
          closable: false,
          summary: "Datos del ETS guardados correctamente",
          life: 1000,
        });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Error guardando los datos:" + errorsInSave,
          life: 5000,
        });
      }
    },
    cancel(){
      //console.log("ETSForm-cancel", this.ship);
      this.shipService.selectedShip({});
      router.push({ name: "neobuqHome" });
    }
  }

};

</script>

<style scoped>

.input-box{
  border-style: dotted;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}

.output-box{
  border-style: solid;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}

.button{
  height: 70px;
  border-radius: 20px;
  text-align: center;
}

</style>